export default __webpack_public_path__ + "edefcb9e8e52ef39ce7fdef6eab4b904.webp";